<template>
  <div
    id="sidebar"
    :style="{ display: $store.state.view == 'sidebar' ? 'block' : 'none' }"
    class="sidebar"
    :class="{ 'dark-mode': store.state.dark }"
  >
    <template class="tabcontent" v-if="!!$store.state.sidebar">
      <KeepAlive>
        <Info v-if="$store.state.sidebar == 'info'"></Info>
      </KeepAlive>
      <Date v-if="$store.state.sidebar == 'date'"></Date>
      <Territories v-if="$store.state.sidebar == 'keys'" />
      <ArrowBlock v-if="$store.state.sidebar == 'keys' && $store.state.war == 'suez-crisis'" />
      <IconBlock v-if="$store.state.sidebar == 'keys'" />
      <CopyrightBlock v-if="$store.state.sidebar == 'keys'" />
    </template>
  </div>
  <div class="sidebar-2"
    :style="{ display: $store.state.view == 'sidebar' ? 'block' : 'none' }"
  >
    <div class="sidebar-nav">
      <ul class="nav navbar-nav sidebar-links-nav" :class="{ 'dark-mode': store.state.dark }">
        <li>
          <a
            id="info-button"
            class="sidebar-links"
            href="#"
            @click="setSideBar('info')"
            :class="$store.state.sidebar == 'info' ? ' mobile-active' : ''"
          >
            {{ t('sidebar.info') }}
          </a>
        </li>
        <li>
          <a
            id="date-button"
            class="sidebar-links"
            href="#"
            @click="setSideBar('date')"
            :class="$store.state.sidebar == 'date' ? ' mobile-active' : ''"
          >
            {{ t('sidebar.date') }}
          </a>
        </li>
        <li style="width: 34%">
          <a
            id="keys-button"
            class="sidebar-links"
            href="#"
            @click="setSideBar('keys')"
            :class="$store.state.sidebar == 'keys' ? ' mobile-active' : ''"
          >
            {{ t('sidebar.keys') }}
          </a>
        </li>
      </ul>
    </div>
    <div class="sidebar-bottom-nav">
      <ul class="nav navbar-nav sidebar-bottom-links-nav">
        <li :style="{backgroundColor: store.state.dark ? '#3747AD' : '#7289da'}">
          <a id="discord-button" href="https://discord.gg/qftqDpY" target="_blank">
            <font-awesome-icon :icon="['fab', 'discord']" />
            {{ t('sidebar.discord') }}
          </a>
        </li>
        <li :style="{backgroundColor: store.state.dark ? '#962516' : '#f96854'}">
          <a id="patreon-button" href="https://www.patreon.com/projectwaw" target="_blank">
            <font-awesome-icon :icon="['fab', 'patreon']" />
            {{ t('sidebar.patreon') }}
          </a>
        </li>
        <li style="width: 34%;" :style="{backgroundColor: store.state.dark ? '#056ABC' : '#1da1f2'}">
          <a id="twitter-button" href="https://twitter.com/ProjectWAW" target="_blank">
            <font-awesome-icon :icon="['fab', 'x-twitter']" />
            {{ t('sidebar.twitter') }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { watch, nextTick } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';

import Date from '@/components/Sidebar/Date.vue';
import Info from '@/components/Sidebar/Info.vue';

import Territories from '@/components/Sidebar/mapKeys/territories.vue';
import ArrowBlock from '@/components/Sidebar/mapKeys/arrowBlock.vue';
import IconBlock from '@/components/Sidebar/mapKeys/iconBlock.vue';
import CopyrightBlock from '@/components/Sidebar/mapKeys/copyrightBlock.vue';

const { t } = useI18n();

const store = useStore();

function setSideBar(state) {
  store.commit('setSidebar', state);
}

watch(() => store.state.scrollTargetId, async (newId) => {
  if (newId) {
    await nextTick();

    location.href = '#' + newId;

    setTimeout(() => {
      if (location.hash === '#' + newId) {
        location.href = '#';
      }
    }, 4000);

    store.commit('setScrollTargetId', null);
  }
});
</script>

<style lang="scss" scoped>
.navbar {
  -webkit-box-shadow: 0 0 0;
  box-shadow: 0 0 0;
}

.nav > li > a:hover,
.nav > li > a:focus {
  background-color: transparent;
}

.mobile-active {
  border-bottom: 2px solid #6b553b !important;
}

#sidebar {
  width: 399px;
  position: fixed;
  overflow-y: auto;
  right: 0;
  bottom: 50px;
  top: 100px;
  background-color: #fafaf5;
  box-shadow: -4px 0 6px rgba(0, 0, 0, 0.12);
  z-index: 500;
}

[dir='rtl'] #sidebar {
  right: auto;
  left: 0;
  box-shadow: 4px 0 6px rgba(0, 0, 0, 0.12);
}

.sidebar-2 ul {
  height: 50px;
  box-shadow: -4px 0 6px rgba(0, 0, 0, 0.12);
  z-index: 500;
}

[dir='rtl'] .sidebar-2 ul {
  box-shadow: 4px 0 6px rgba(0, 0, 0, 0.12);
}

.sidebar-2 ul li {
  float: left;
  width: 33%;
  text-align: center;
}

.sidebar-2 ul li a {
  height: 50px;
  line-height: 22px;
  color: #ffffff;
}

.sidebar-links-nav {
  background-color: #bba58e;
  margin: 0;
  display: flex;
  width: 399px;
}

[dir='rtl'] .sidebar-links-nav .sidebar-bottom-links-nav {
  direction: rtl;
}

[dir='rtl'] ul {
  padding-right: 0;
  padding-inline-start: 0 !important;
}

.sidebar-links {
  border-bottom: 2px solid #e7e7e7;
  background-color: #bba58e;
}

.sidebar-links:focus,
.sidebar-links:active,
.sidebar-links:hover {
  outline: none;
}

.sidebar-nav {
  position: -webkit-fixed;
  position: fixed;
  top: 50px;
  right: 0;
  width: 399px;
  z-index: 800;
  box-sizing: border-box;
}

.sidebar-bottom-nav {
  position: -webkit-fixed;
  position: fixed;
  bottom: 0;
  right: 0;
  width: 399px;
  z-index: 800;
  box-sizing: border-box;
}

.sidebar-bottom-links-nav {
  display: flex;
  width: 100%;
  line-height: normal;
}

[dir='rtl'] .sidebar-nav,
[dir='rtl'] .sidebar-bottom-nav,
[dir='rtl'] .sidebar-bottom-links-nav {
  left: 0;
}

hr {
  height: 1px;
  background-color: darkgray;
  border: none;
  margin-top: 18px;
  margin-bottom: 18px;
}

.key-hr {
  background-color: #dedede;
}

.tabcontent {
  padding: 1em;
}

.MuiTooltip-popper {
  z-index: 1000;
}

#sidebar.dark-mode,
.sidebar.dark-mode {
  background-color: #121722;
  color: #E6EAF2;
}

.sidebar-links-nav.dark-mode {
  background-color: #384577;
}

.sidebar-links-nav.dark-mode .sidebar-links {
  border-bottom: 2px solid #2b364d;
  background-color: #242c4b;
  color: #E6EAF2;
}

.sidebar-links-nav.dark-mode .sidebar-links.mobile-active {
  border-bottom: 2px solid #5a6697 !important;
}

@media screen and (max-width: 899px) ,screen and (max-height: 500px) {
  #sidebar {
    top: 130px;
    background-color: #fafaf5;
  }

  #sidebar ul li a {
    line-height: 28px;
  }
  .sidebar-2 .navbar-nav>li>a {
    padding-top: 15px;
    padding-bottom: 10px;
  }

  .sidebar-nav {
    top: 80px;
  }

  #sidebar,
  .sidebar-bottom-links-nav,
  .sidebar-nav,
  .sidebar-bottom-nav,
  .nav,
  .navbar-nav {
    width: 100vw;
    z-index: 2;
  }

  .navbar-nav {
    margin: 0;
  }
}
</style>
